import React from 'react'
import TextField from '@material-ui/core/TextField';
import Autocomplete from "../Autocomplete/AutocompleteVirtualized";
import css from "./Inputs.module.css"

const Input = (props) => {
    return (
        <div className={css.Inputs}>
            <div className={css.InputsTitleContainer}>
                <h4>{props.title}</h4>
                {props.error ? (
                    <p className={css.errorTxt}>{props.error}</p>
                ) : null}
            </div>
            <Autocomplete options={props.calles} handleCalleIdChange={props.handleCalleIdChange}  handleCalleChange={props.handleCalleChange} calle={props.calle} />
            <TextField margin="dense" label="Numero" variant="outlined" onChange={props.handleNumeroChange} value={props.numero} />
        </div>
    )
}

export default Input
